import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { ImageUpscalePage } from '@/components/custom/image-upscale-page';
import { getImageUpscaleSeoData } from '@/components/custom/image-upscale-seo-data';
import { seo } from '@/lib/seo';

const searchSchema = z.object({
  sourceImageId: z.string().min(1).optional(),
  sourceOutputIndex: z.coerce.number().int().nonnegative().optional(),
});

export const Route = createFileRoute('/image-upscale')({
  validateSearch: searchSchema,
  head: () => {
    const data = getImageUpscaleSeoData();
    return seo(data.path, {
      title: data.seoTitle,
      description: data.seoDescription,
      keywords: data.keywords,
    });
  },
  component: ImageUpscaleRoute,
});

function ImageUpscaleRoute() {
  const search = Route.useSearch();
  return (
    <ImageUpscalePage
      sourceImageId={search.sourceImageId}
      sourceOutputIndex={search.sourceOutputIndex}
    />
  );
}
